import composeInstallation from '../utils/composeInstallation'

const install = composeInstallation({
  name: 'checkout',
  scriptId: 'checkout-js',
  makeScriptUri: () => 'https://cdn.checkout.com/js/framesv2.min.js'
})

export { install }
